import * as React from 'react';

type BasicCrownIconProps = {
  width?: number,
  height?: number,
  color?: string,
  strokeColor?: string,
} & React.SVGProps<SVGSVGElement>;

export const BasicCrownIcon = ({
  width,
  height,
  color,
  strokeColor,
  ...restProps
}: BasicCrownIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 38 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>Crown Icon</title>
    <g id="one-off-icons" stroke="none" strokeWidth="1" fill={color} fillRule="evenodd">
      <path
        d="M2,4 C3,3.66666667 4,3.33333333 5,3 L13,22 L17,1 L21,1 L25,22 L33,3 L36,4 L33,35 L5,35 L2,4 Z"
        id="Path-7"
        stroke={strokeColor}
        strokeWidth="2"
      />
    </g>
  </svg>
);

BasicCrownIcon.defaultProps = {
  width: 38,
  height: 36,
  color: 'none',
  strokeColor: 'none',
};
